/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { LocalizedPolicy, PolicyList, Policy } from "../../api/legal/models/policies";
import BaseLogic from "../../utils/BaseLogic";

interface AccordionDataLocalizedPolicy {
  name: string;
  localizedPolicy: LocalizedPolicy;
}

export interface AccordionData {
  namespace: string;
  activeLocalizedPolicyId: string | null;
  policies: AccordionDataLocalizedPolicy[];
}

interface Props {
  policies: PolicyList;
  activeLanguage: string;
  activeLocalizedPolicyId: string;
}
interface State {
  activeLanguage: string;
  accordionData: { [key: string]: AccordionData };
}

export default class DocumentFilterAccordionLogic extends BaseLogic<State> {
  private readonly props: Props;

  constructor(props: Props) {
    super();
    this.props = props;
    this.state = {
      activeLanguage: props.activeLanguage,
      accordionData: {},
    };
  }

  init() {
    this.setUpAccordionData();
  }

  async setUpAccordionData() {
    const { policies, activeLocalizedPolicyId } = this.props;

    const { activeLanguage } = this.state;
    await this.setState({ accordionData: {} });

    let accordionData: { [key: string]: AccordionData } = {};
    await policies.forEach(async (policy: Policy) => {
      if (policy.namespace && (!!policy.policyVersions && policy.policyVersions.length)) {
        let newAccordionData: AccordionData = {
          namespace: policy.namespace,
          activeLocalizedPolicyId: null,
          policies: [],
        };

        // Only get first data since first data is the latest version
        if (
          !!policy.policyVersions[0].localizedPolicyVersions &&
          policy.policyVersions[0].localizedPolicyVersions.length
        ) {
          await policy.policyVersions[0].localizedPolicyVersions.forEach(async (localizedPolicy: LocalizedPolicy) => {
            if (localizedPolicy.localeCode === activeLanguage && policy.namespace) {
              // Only display localized policy that match with active language

              newAccordionData.policies.push({
                name: policy.policyName,
                localizedPolicy,
              });

              if (!!activeLocalizedPolicyId && localizedPolicy.id === activeLocalizedPolicyId) {
                newAccordionData.activeLocalizedPolicyId = localizedPolicy.id;
              }
            }
          });
        }

        if (!!accordionData[newAccordionData.namespace]) {
          if (!!newAccordionData.activeLocalizedPolicyId) {
            accordionData[newAccordionData.namespace].activeLocalizedPolicyId =
              newAccordionData.activeLocalizedPolicyId;
          }
          accordionData[newAccordionData.namespace].policies.push(...newAccordionData.policies);
        } else {
          accordionData = Object.assign(
            {
              [newAccordionData.namespace]: newAccordionData,
            },
            accordionData
          );
        }
      }
    });
    await this.setState({
      accordionData,
    });
  }
}
